import React, { useState, useEffect } from 'react'
import BreadCrumbComp from '../../../components/breadCrumb'
import { Grid } from '@mui/material'
import { useForm } from 'react-hook-form'
import { useParams } from 'react-router-dom'
import { callApiAsync, getInternalClientSatisfactionQuestions } from '../../../services/apiService'
import FormTextField from '../../../components/textField/formTextField'
import LaddaButton from '../../../components/buttons/laddaButton'
import CustomSnackbar from '../../../components/snackbar'

const AnswerSurvey = () => {
    const { token } = useParams()
    const [loading, setLoading] = useState(false)
    const [questions, setQuestions] = useState([])
    const [snackbarOpen, setSnackbarOpen] = useState(false)
    const [snackbarMessage, setSnackbarMessage] = useState('')
    const [snackbarSeverity, setSnackbarSeverity] = useState('success')

    const {
        control,
        handleSubmit,
        setValue,
        formState: { errors }
    } = useForm({
        defaultValues: {
            respuesta1: '',
            respuesta2: '',
            respuesta3: '',
            respuesta4: '',
            respuesta5: '',
            respuesta6: '',
            respuesta7: '',
            respuesta8: '',
            respuesta9: '',
            respuesta10: ''
        }
    })

    useEffect(() => {
        loadQuestions()
    }, [])

    const loadQuestions = async () => {
        setLoading(true)
        await callApiAsync(
            () => getInternalClientSatisfactionQuestions(),
            (resp) => {
                const data = resp?.data ?? resp
                const questionsData = Array.isArray(data) ? data : []
                
                // Ordenar por questionNumber
                const sortedQuestions = [...questionsData].sort((a, b) => a.questionNumber - b.questionNumber)
                setQuestions(sortedQuestions)
                setLoading(false)
            },
            setLoading
        )
    }

    const onSubmit = async (formData) => {     
        setSnackbarMessage('Encuesta enviada correctamente (por ahora solo se imprime en consola)')
        setSnackbarSeverity('success')
        setSnackbarOpen(true)
    }

    return (
        <div>
            <BreadCrumbComp />
            <div className="searchTitle">
                <h1>ENCUESTA SATISFACCIÓN CLIENTE INTERNO</h1>
            </div>

            <div className="table-container">
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="mb-20">
                        <h2 className="title-bio-details-chard" style={{ marginBottom: '20px' }}>
                            ENCUESTA SATISFACCIÓN CLIENTE INTERNO
                        </h2>

                        <Grid container spacing={3}>
                            {questions.map((question) => (
                                <Grid item xs={12} key={question.id}>
                                    <div className="mb-15">
                                        <p className="select-form-label">Pregunta {question.questionNumber}</p>
                                        <p className="detail-label" style={{ marginBottom: '10px', fontSize: '14px' }}>
                                            {question.questionText}
                                        </p>
                                        <FormTextField
                                            name={`respuesta${question.questionNumber}`}
                                            control={control}
                                            isTextArea={true}
                                            rows={3}
                                            margin={"0"}
                                            placeholder="Escriba su respuesta aquí..."
                                            error={errors[`respuesta${question.questionNumber}`]}
                                        />
                                    </div>
                                </Grid>
                            ))}
                        </Grid>
                    </div>

                    <div className="HContainer j-center" style={{ marginTop: '30px' }}>
                        <LaddaButton
                            type="submit"
                            variant="contained"
                            backgroundColor="#6C5CE7"
                            height="50px"
                            borderRadius="15px"
                            width="400px"
                            disabled={loading}
                        >
                            <div className="IHContainer align-center">
                                <p className="button_text">Enviar Encuesta</p>
                            </div>
                        </LaddaButton>
                    </div>
                </form>
            </div>

            <CustomSnackbar
                open={snackbarOpen}
                message={snackbarMessage}
                severity={snackbarSeverity}
                onClose={() => setSnackbarOpen(false)}
            />
        </div>
    )
}

export default AnswerSurvey
